module.exports = __webpack_public_path__ + "static/media/diya_indoliya.e9bb078d.png";